module.exports = __webpack_public_path__ + "img/get-bonus-points.aa847d6f.png";